module.exports = __webpack_public_path__ + "static/DSC_9516-2d65a0bcd0392cfd640074206cb6730b.jpg";